import React, { useState } from 'react';
import axios from 'axios';
import Button from '../Button';
import { FaUser, FaEnvelope, FaPhone, FaCalendarAlt, FaClock, FaMapMarkerAlt, FaUsers } from 'react-icons/fa';
import { motion } from 'framer-motion';

export default function Orcamento() {
  const valorTelefone = (e) => {
    let textoAjustado = e.replace(/(\d{2})(\d{5})(\d{4})/, '$1 $2 $3');
    setTelefone(textoAjustado);
  };

  const [nome, setNome] = useState('');
  const [email, setEmail] = useState('');
  const [telefone, setTelefone] = useState('');
  const [dataEvento, setDataEvento] = useState('');
  const [horaEvento, setHoraEvento] = useState('');
  const [localEvento, setLocalEvento] = useState('');
  const [numPessoas, setNumPessoas] = useState('');
  const [mensagem, setMensagem] = useState('');
  const [statusEnvio, setStatusEnvio] = useState({ type: '', mensagem: '' });

  const onSubmit = async (e) => {
    e.preventDefault();
    try {
      const { data } = await axios.post('https://congolinaria.com.br/add_orcamento.php', {
        nome,
        email,
        whatsapp: telefone,
        mensagem,
        data_evento: dataEvento,
        hora_evento: horaEvento,
        endereco_evento: localEvento,
        numero_pessoa: numPessoas,
      });

      setStatusEnvio({
        type: data.erro ? 'error' : 'success',
        mensagem: data.mensagem,
      });
    } catch {
      setStatusEnvio({ type: 'error', mensagem: 'Tente mais tarde!' });
    }
  };

  return (
    <section className="py-16 px-4 sm:px-6 bg-gradient-to-br from-yellow-50 to-white" id="order">
      <motion.h2
        className="text-3xl sm:text-4xl font-bold text-center text-red-700 mb-10"
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        <span className="border-b-4 border-yellow-400 pb-1">Solicite seu Orçamento</span>
      </motion.h2>

      <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-10 items-start">
        <motion.div
          className="space-y-6"
          initial={{ opacity: 0, x: -30 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8 }}
        >
          <img
            src={`${process.env.PUBLIC_URL}/pratos/chef-pitchou.jpg`}
            alt="Chef Pitchou"
            className="rounded-2xl shadow-lg w-full object-cover h-64 sm:h-full"
          />
          <div className="bg-green-100 text-green-800 p-4 rounded-lg text-center text-sm font-medium shadow">
            🍲 Mais de <strong>100 eventos</strong> atendidos com excelência!
          </div>
          <p className="text-gray-600 leading-relaxed text-sm sm:text-base">
            Nosso cardápio é montado com exclusividade para seu evento, com ingredientes frescos e tradição congolesa.
          </p>
        </motion.div>

        <motion.div
          className="bg-white shadow-xl rounded-xl p-4 sm:p-6 space-y-6 border border-yellow-200"
          initial={{ opacity: 0, x: 30 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8 }}
        >
          {statusEnvio.type && (
            <div className={`p-3 rounded text-white ${statusEnvio.type === 'success' ? 'bg-green-600' : 'bg-red-600'}`}>
              {statusEnvio.mensagem}
            </div>
          )}

          <form onSubmit={onSubmit} className="space-y-4 w-full max-w-full">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <div className="relative">
                <FaUser className="absolute left-3 top-3 text-gray-400" />
                <input type="text" placeholder="Nome completo" className="input-field pl-10 w-full" onChange={(e) => setNome(e.target.value)} />
              </div>
              <div className="relative">
                <FaEnvelope className="absolute left-3 top-3 text-gray-400" />
                <input type="email" placeholder="E-mail" className="input-field pl-10 w-full" onChange={(e) => setEmail(e.target.value)} />
              </div>
              <div className="relative">
                <FaPhone className="absolute left-3 top-3 text-gray-400" />
                <input type="text" placeholder="WhatsApp" value={telefone} className="input-field pl-10 w-full" maxLength={11} pattern="[0-9\s]+" onChange={(e) => valorTelefone(e.target.value)} />
              </div>
              <div className="relative">
                <FaUsers className="absolute left-3 top-3 text-gray-400" />
                <input type="number" placeholder="Nº de Pessoas" className="input-field pl-10 w-full" onChange={(e) => setNumPessoas(e.target.value)} />
              </div>
              <div className="relative">
                <FaMapMarkerAlt className="absolute left-3 top-3 text-gray-400" />
                <input type="text" placeholder="Endereço do Evento" className="input-field pl-10 w-full" onChange={(e) => setLocalEvento(e.target.value)} />
              </div>
              <div className="relative">
                <FaCalendarAlt className="absolute left-3 top-3 text-gray-400" />
                <input type="date" className="input-field pl-10 w-full" onChange={(e) => setDataEvento(e.target.value)} />
              </div>
              <div className="relative">
                <FaClock className="absolute left-3 top-3 text-gray-400" />
                <input type="time" className="input-field pl-10 w-full" onChange={(e) => setHoraEvento(e.target.value)} />
              </div>
            </div>
            <textarea rows={4} placeholder="Observações" className="input-field w-full" onChange={(e) => setMensagem(e.target.value)}></textarea>
            <Button Text="Enviar Solicitação 🎉" />
          </form>
        </motion.div>
      </div>
    </section>
  );
}
